import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TbCalendarEvent, TbMap, TbHeadset } from 'react-icons/tb';

import { useGuestStore } from 'src/App';
import BottomNav from 'src/components/bottom-nav.component';

// outlined take on the stepped hotel tower; lucide-style strokes to match the other icons
const HotelIcon = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
    <path d='M2 21.5h20' />
    <path d='M4 21.5V6.5a1 1 0 0 1 1-1h.5v-2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2h.5a1 1 0 0 1 1 1v15' />
    <path d='M10 21.5v-4.5h4v4.5' />
    <path d='M9 4.5v1M12 4.5v1M15 4.5v1' />
    <path d='M7.5 8.5v1.5M10.5 8.5v1.5M13.5 8.5v1.5M16.5 8.5v1.5' />
    <path d='M7.5 12.5v1.5M10.5 12.5v1.5M13.5 12.5v1.5M16.5 12.5v1.5' />
    <path d='M7 16.5v1.5M17 16.5v1.5' />
  </svg>
);

const tiles = [
  { label: 'Agenda', Icon: TbCalendarEvent, to: '/agenda' },
  { label: 'Hotel', Icon: HotelIcon, to: 'https://maps.app.goo.gl/rPoTwprFn53VV4Tx7' },
  { label: 'Map', Icon: TbMap, to: 'https://maps.app.goo.gl/rPoTwprFn53VV4Tx7' },
  { label: 'Support', Icon: TbHeadset, to: 'https://wa.me/966504108080' },
];

// no features string: Safari would open a popup window instead of a tab
const openTab = (url) => {
  const w = window.open(url, '_blank');
  if (w) w.opener = null;
};

const greeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning.';
  if (hour < 18) return 'Good afternoon.';
  return 'Good evening.';
};

const HomePage = () => {

  document.title = 'SNB Nexus 2026';

  const name = useGuestStore((state) => state.name)

  const navigate = useNavigate()

  // re-check the time each minute and when the app returns from the background,
  // so a tab left open (or restored by iOS) doesn't keep a stale greeting
  const [hello, setHello] = useState(greeting)
  useEffect(() => {
    const update = () => setHello(greeting())
    const timer = setInterval(update, 60000)
    document.addEventListener('visibilitychange', update)
    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', update)
    }
  }, [])

  return (
    <div className='home-wrapper app-wrapper home-page'>
      <div className='page-content'>
        <div className='home-header'>
          <p className='home-greeting'>{hello}</p>
        </div>
        <h1 className='home-name'>{name}</h1>
        <p className='home-subtitle'>Welcome to SNB Nexus 2026</p>

        <div className='home-grid'>
          {tiles.map(({ label, Icon, to }) => (
            <button key={label} className='home-tile' onClick={() => (to.startsWith('http') ? openTab(to) : navigate(to))}>
              <span className='home-tile-icon'><Icon /></span>
              {label}
            </button>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default HomePage;
